var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Alert",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle",
    transform: "translate(2.000000, 3.000000)",
    stroke: "#000000",
    strokeWidth: 1.33333333
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.82534597,0.641829336 L0.178679299,10.068496 C-0.0582262824,10.4787624 -0.0596407451,10.9839273 0.174963646,11.3955139 C0.409568037,11.8071006 0.844953977,12.0632892 1.3186793,12.068496 L12.6120126,12.068496 C13.085738,12.0632892 13.5211239,11.8071006 13.7557283,11.3955139 C13.9903327,10.9839273 13.9889182,10.4787624 13.7520126,10.068496 L8.10534597,0.641829336 C7.86363552,0.243350217 7.43140342,0 6.96534597,0 C6.49928852,0 6.06705641,0.243350217 5.82534597,0.641829336 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.96534597,
    y1: 4.068496,
    x2: 6.96534597,
    y2: 6.73516267,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.96534597,
    y1: 9.40182934,
    x2: 6.97201263,
    y2: 9.40182934,
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.12cb2423730b4ca3b0f41d5a41550f0d.svg";
export { ForwardRef as ReactComponent };